// Loader.js
import React from 'react';
import { CircleLoader } from 'react-spinners';
import './loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <CircleLoader color="#002366" size={100} />
      <CircleLoader color="#66CDAA" size={100} />
      <CircleLoader color="#FFA500" size={100} />
    </div>
  );
};

export default Loader;
